import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

function HeaderTitle({ color, text }) {
  return (
    <Typography
      variant="h6"
      sx={{ color, ml: 1 }}
      noWrap
    >
      { text }
    </Typography>
  );
}

HeaderTitle.defaultProps = {
  color: '',
};

HeaderTitle.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default HeaderTitle;
